import { _get, _post } from "../../../../http";

// cuentas bancarias para la editorial
export const getCuentasBancariasEditorial = (editorialId) => _get(`/cuentaBancaria/editoriales/${editorialId}`);

export const postCuentasBancariasEditorial = (editorialId, body) =>
  _post(`/cuentaBancaria/editoriales/${editorialId}`, body);
